import WNavigatorBar from './WNavigatorBar'

export { WNavigatorBar }
export default WNavigatorBar
